<template>
  <el-aside width="201px" class="tableNav nice_scroll">
    <!-- 设置 -->
    <el-row class="flexCenter doubleBtns">
      <p class="p0-p15 fwb">{{$t("wm_lang_html_e366cc")}}</p>
    </el-row>
    <el-menu
      class="ztree"
      @open="handleOpen"
      :default-active="activeIndex"
      background-color="#f5f6f7"
      @close="handleClose">
      <div class="tree_account">
      <el-menu-item index="1">
        <router-link to="/setting/userInfo">
        <i class="icon el-icon-setInfor"></i>
        <span>{{$t("wm_lang_html_53cab4")}}</span>
        </router-link>
      </el-menu-item>
      <el-menu-item index="2" v-if="accountSecurityPriv">
        <router-link to="/setting/accountSecurity">
        <i class="icon el-icon-security"></i>
        <span>{{$t("wm_lang_html_4404d5")}}</span>
        </router-link>
      </el-menu-item>
      <el-menu-item index="3" v-if="otherEmailAccountPriv">
        <router-link to="/setting/otherEmailAccount">
        <i class="icon el-icon-setPOP"></i>
        <span>{{$t("wm_lang_html_7fe4a6")}}(POP)</span>
        </router-link>
      </el-menu-item>
      <el-menu-item index="4">
        <router-link to="/setting/folderManage">
        <i class="icon el-icon-wiztree"></i>
        <span>{{$t("wm_lang_html_c3eb73")}}</span>
        </router-link>
      </el-menu-item>
      </div>
      <div class="tree_account">
      <!--<el-menu-item direction index="5">-->
        <!--<router-link to="/setting/setComponent">-->
        <!--<i class="icon el-icon-setLang"></i>-->
        <!--<span>{{$t("wm_lang_html_4de530")}}</span>-->
        <!--</router-link>-->
      <!--</el-menu-item>-->
      <!--<el-menu-item index="6">-->
        <!--<router-link to="/setting/setComponent">-->
        <!--<i class="icon el-icon-skinChange"></i>-->
        <!--<span>{{$t("wm_lang_html_38294f")}}</span>-->
        <!--</router-link>-->
      <!--</el-menu-item>-->
      <el-menu-item index="5">
        <router-link to="/setting/generalSettings">
          <i class="icon el-icon-AdSettings"></i>
          <span>{{$t("wm_lang_html_d4095c")}}</span>
        </router-link>
      </el-menu-item>
      <el-menu-item index="6">
        <router-link to="/setting/clientSetting">
          <i class="icon el-icon-mailSettings"></i>
          <span>{{$t("wm_lang_html_2cb96f")}}</span>
        </router-link>
      </el-menu-item>
      <el-menu-item index="7">
        <router-link to="/setting/signatureSetting">
        <i class="icon el-icon-indivSign"></i>
        <span>{{$t("wm_lang_html_bffb1c")}}</span>
        </router-link>
      </el-menu-item>
      <!--<el-menu-item index="8">-->
        <!--<router-link to="/setting/setComponent">-->
        <!--<i class="icon el-icon-AdSettings"></i>-->
        <!--<span>{{$t("wm_lang_html_e37075")}}</span>-->
        <!--</router-link>-->
      <!--</el-menu-item>-->
      </div>
      <div class="tree_account">
      <el-menu-item index="8">
        <router-link to="/setting/classificationRules">
        <i class="icon el-icon-mailRules"></i>
        <span>{{$t("wm_lang_html_8e16eb")}}</span>
        </router-link>
      </el-menu-item>
      <!--<el-menu-item index="10">-->
        <!--<router-link to="/setting/setComponent">-->
        <!--<i class="icon el-icon-mailSettings"></i>-->
        <!--<span>{{$t("wm_lang_html_6b05b5")}}</span>-->
        <!--</router-link>-->
      <!--</el-menu-item>-->
      <el-menu-item index="9">
        <router-link to="/setting/forwardReply">
        <i class="icon el-icon-forwarded"></i>
        <span>{{$t("wm_lang_html_ca5b2d")}}</span>
        </router-link>
      </el-menu-item>
      </div>
      <div class="tree_account">
      <el-menu-item index="10">
        <router-link to="/setting/blacklist">
        <i class="icon el-icon-blacklist"></i>
        <span>{{$t("wm_lang_html_bcbfe2")}}</span>
        </router-link>
      </el-menu-item>
      <el-menu-item index="11">
        <router-link to="/setting/antiSpamSetting">
        <i class="icon el-icon-antiSettings"></i>
        <span>{{$t("wm_lang_html_8becc4")}}</span>
        </router-link>
      </el-menu-item>
      </div>
    </el-menu>
  </el-aside>
</template>

<script>
  import xmail from '@/api/api';
  import storeLocal from 'store';
  import { bitIs1 } from '@/utils/utils';
export default {
  name: 'Aside',
  data () {
    return {
      msgindex: this.$i18n.t('wm_lang_361e3d'),
      localConfigSetting: {},
      otherEmailAccountPriv: false,
      accountSecurityPriv: false,
      activeIndex: '4'
    }
  },
  watch: {
    $route(to) {
      // console.log(to)
      if(this.$route.params) {
        this.activeIndex = this.$route.params.activeIndex;
      }
    }
  },
  mounted() {
    this.localConfigSetting = storeLocal.get('Pwm-configSetting');
    this.otherEmailAccountPriv = bitIs1(this.localConfigSetting.priviage.priviage1, xmail.enums.UserPrivilege.MAIL_COLLECTION);
    this.accountSecurityPriv = bitIs1(this.localConfigSetting.priviage.priviage1, xmail.enums.UserPrivilege.ACCOUNT_SAFE);
    if(this.$route.params) {
      this.activeIndex = this.$route.params.activeIndex;
    }
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/sub/asideSet.vue